export function SchoolIcon({
  className,
}: {
  readonly className?: string;
}): React.JSX.Element {
  // Canonical KlassMate source:
  // klassmate-board-react/src/assets/icons/school-icon.svg.
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M28.5714 29.7143V17.7371C28.5711 17.3697 28.4824 17.0076 28.3127 16.6817C28.1431 16.3557 27.8974 16.0754 27.5966 15.8643L17.1429 8.54857V6.85714H24V0H14.8571V8.54857L4.4032 15.8655C4.10239 16.0764 3.85677 16.3566 3.68713 16.6825C3.51749 17.0084 3.4288 17.3703 3.42857 17.7377V29.7143H0V32H32V29.7143H28.5714ZM17.1429 2.28571H21.7143V4.57143H17.1429V2.28571ZM5.71429 17.7377L16 10.5377L26.2857 17.7377V29.7143H17.1429V20.5714H14.8571V29.7143H5.71429V17.7377Z"
        fill="currentColor"
      />
    </svg>
  );
}
